import * as ActionCable from 'actioncable'
import { Subscription } from "@rails/actioncable";
// import { domainName } from '../lib/enviroment'

/**
 * subscribeするときに必要となる
 */
const httpProtocol = location.protocol
const websocketProtocol = httpProtocol === 'https:' ? 'wss:' : 'ws:'
const domainName = window.location.host
const cable = ActionCable.createConsumer(
  `${websocketProtocol}//${domainName}/cable/`
)

// interface ChatChannel {
//   channel: Channel
//   chatRoomUuid: string // eslint-disable-line camelcase
// }

// interface UserChannel {
//   channel: Channel
//   userUuid: string // eslint-disable-line camelcase
// }
const defaultReceivedCallback = (data) => {
  /* */
}

const defaultConnectedCallback = () => {
  /* */
}
const defaultDisconnectedCallback = () => {
  /* */
}
const defaultRejectedCallback = () => {
  /* */
}

export const makeChannel = (
  channel = 'NotificationChannel',
  receivedCallback = defaultReceivedCallback,
  connectedCallback = defaultConnectedCallback,
  disconnectedCallback = defaultDisconnectedCallback,
  rejectedCallback = defaultRejectedCallback
) => {
  return cable.subscriptions.create(
    // channel対象を指定
    { channel: channel, from: window.location.href },
    {
      // channel成功時
      connected: () => {
        connectedCallback()
      },
      // channel終了時
      disconnected: () => {
        disconnectedCallback()
      },
      // channel拒否時
      rejected: () => {
        rejectedCallback()
      },
      // メッセージ受信時
      received: (data) => {
        if (!data) return
        receivedCallback(data)
      }
    }
  )
}

export const removeChannel = (channel: string) => {
  const subscriptions = cable.subscriptions.subscriptions
    .filter((s: Subscription) => s && s.identifier && s.identifier.includes(channel))
  subscriptions.forEach((subscription: Subscription) => {
    cable.subscriptions.remove(subscription)
  })
}
